import { useCallback } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import SyncAltIcon from '@mui/icons-material/SyncAlt';

import MoveMoneyChoiceViewModal from '#client/components/MoveMoney/MoveMoneyChoiceViewModal';
import { MODAL_NAMES } from '#client/constants/modals';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';
import useModalContext from '#client/hooks/useModalContext';

export default function MoveMoneyButton() {
  const { isDisable } = useDisableDashboardContext();
  const { openModal } = useModalContext();
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const handleButtonPress = useButtonPressedCallback({
    elementName: 'move_money_button',
    elementText: 'Move money',
    appPageName: 'active_banking_dashboard'
  });

  const handleOpenMoveMoneyModal = useCallback(() => {
    handleButtonPress();
    openModal({
      component: MoveMoneyChoiceViewModal,
      name: MODAL_NAMES.MOVE_MONEY_CHOICE_VIEW_MODAL
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  return (
    <Button
      disabled={isDisable}
      fullWidth
      icon={!isMobile ? <SyncAltIcon color="text.white" /> : undefined}
      onClick={handleOpenMoveMoneyModal}
      size="small"
      variant="contained"
    >
      Move money
    </Button>
  );
}
